export default "__VITE_ASSET__kUyQ8cO1__"